module.exports = __webpack_public_path__ + "static/media/Bellissimo coffee drinks.c84dd903.png";